module.exports = __webpack_public_path__ + "img/login.e89f4517.jpg";